module.exports = __webpack_public_path__ + "img/008-estonia.ef471eeb.svg";